import PropTypes from 'prop-types';
import Entity from '../../entity/Entity';


/**
 *
 * @param root0
 * @param root0.before
 * @param root0.after
 * @param root0.from
 * @param root0.to
 * @param root0.onChangeTime
 * @param root0.fromHour
 * @param root0.toHour
 * @param root0.isLocalDateAndTime
 * @param root0.isRestricted
 * @param root0.isOutOfRange
 * @param root0.toLimit
 * @returns {JSX} RangePicked
 */
function RangePicked({ before, after, from, to, onChangeTime, fromHour, toHour, isLocalDateAndTime, isRestricted, isOutOfRange, toLimit }) {

    return (
        <div className='flex flex-col'>
            {
                from && !before && !after ?
                    <div className='flex justify-between gap-2 items-center'>
                        <Entity entity='date_picker.from_time'
                            className='text-sm'
                            data={{
                                from: from.toLocaleString()
                            }} />
                        <input
                            type='time'
                            name='fromHour'
                            value={fromHour}
                            min={'00:00'}
                            max={'23:59'}
                            onChange={onChangeTime}
                            pattern='((0\d|1\d)|(2[0-3])):([0-5]\d)'
                            autoComplete='off' />
                    </div>
                    : !from && !before && !after &&
                    <Entity entity='date_picker.from_time_no_date' />
            }
            {
                to && !before && !after ?
                    <div className='flex justify-between gap-2 items-center'>
                        <Entity entity='date_picker.to_time'
                            className='text-sm'
                            data={{
                                to: isRestricted && isOutOfRange ? toLimit.toLocaleString() : to.toLocaleString()
                            }} />
                        <input
                            type='time'
                            name='toHour'
                            value={toHour}
                            min={'00:00'}
                            max={'23:59'}
                            onChange={onChangeTime}
                            pattern='((0\d|1\d)|(2[0-3])):([0-5]\d)'
                            autoComplete='off'
                        />

                    </div>
                    : !to && !before && !after &&
                    <Entity entity='date_picker.to_time_no_date' />
            }
            {
                (from && to || before || after) && isLocalDateAndTime &&
                <Entity entity='date_picker.local_time_zone' className='text-center text-xs italic' />
            }
        </div>
    );
}

RangePicked.propTypes = {
    before: PropTypes.bool,
    after: PropTypes.bool,
    from: PropTypes.object,
    to: PropTypes.object,
    onChangeTime: PropTypes.func,
    fromHour: PropTypes.string,
    toHour: PropTypes.string,
    isLocalDateAndTime: PropTypes.bool,
    isRestricted: PropTypes.bool,
    isOutOfRange: PropTypes.bool,
    toLimit: PropTypes.string
};

export default RangePicked;